"use client"

import { useEffect, useState } from "react"
import { checkLoginStatus, getUserData, updateUserData, logoutUser, getAllUsers } from '../../api/authService';
import {
  getAllComments, fetchTHPRegistrants,
  fetchBBBRegistrants,
  fetchPopMyCherryRegistrants,
  getAllPages,
  fetchLibraryItems,
  syncYouTubeLibrary,
  fetchVTCRegistrants,
  fetchDailyDeclarations,
  fetchBioData,
  getWeeklyLevels,
  fetchPartners,
  fetchVolunteers,
  fetchBSTM
} from '../../api/adminService';
// import { useSearchParams, useRouter } from "next/navigation"
import { AdminSidebar } from "../../components/admin/admin-sidebar"
import { AdminHeader } from "../../components/admin/admin-header"
import { DashboardSection } from "../../components/admin/sections/dashboard-section"
import { UserManagementSection } from "../../components/admin/sections/user-management-section"
import { PortalRegistrantsSection } from "../../components/admin/sections/portal-registrants-section"
import { CommentModerationSection } from "../../components/admin/sections/comment-moderation-section"
import { QRGeneratorSection } from "../../components/admin/sections/qr-generator-section"
import { EmailToolsSection } from "../../components/admin/sections/email-tools-section"
import { EnhancedEmailTools } from "../../components/email-templates/enhanced-email-tools"
import { SliderControlSection } from "../../components/admin/sections/slider-control-section"
import { LinkTreeSection } from "../../components/admin/sections/linktree-section"
import { SocialSEOSection } from "../../components/admin/sections/social-seo-section"
import { SiteSettingsSection } from "../../components/admin/sections/site-settings-section"
import { NotificationsSection } from "../../components/admin/sections/notifications-section"
import { SecurityLogsSection } from "../../components/admin/sections/security-logs-section"
import { SidebarProvider, SidebarInset } from "../../components/ui/sidebar"
import { LibrarySettingsSection } from "../../components/admin/sections/library-settings-section";
import { Toast } from "../../components/Toast";
import { DailyDeclarationSection } from "../../components/admin/sections/daily-declarations-section";
import { BioDataFormSection } from "../../components/admin/sections/bio-data-form-section";
import { WeeklyGameAdminSection } from "../../components/admin/sections/weelky-game";
import { PartnerFormSection } from "../../components/admin/sections/partner-form-section";
import { VolunteersFormSection } from "../../components/admin/sections/volunteers-form-section";
import HealingPavilionDashboard from "../../components/admin/sections/bookings/dashboard";
import HealingPavilionAvailabilityManagementPage from "../../components/admin/sections/bookings/availability";
import HealingPavilionBookingsPage from "../../components/admin/sections/bookings/bookings";
import HealingPavilionSettingsPage from "../../components/admin/sections/bookings/settings";
import { BiblestudyMasterclassSection } from "../../components/admin/sections/biblestudy-masterclass-section";
const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;
// import './globals.css'

export default function AdminPage() {
  // const searchParams = useSearchParams()
  // const router = useRouter()
  const [activeSection, setActiveSection] = useState("dashboard")

  const [allUsers, setAllUsers] = useState([]);
  const [adminUsers, setAdminUsers] = useState([]);
  const [comments, setComments] = useState([]);
  const [portals, setPortals] = useState<any>([]);
  const [allPages, setAllPages] = useState<any>([]);
  const [declarations, setDeclarations] = useState<any>([])
  const [bioDataList, setBioDataList] = useState<any>([])
  const [partnerFormList, setPartnerFormList] = useState<any>([])
  const [volunteersFormList, setVolunteersFormList] = useState<any>([])
  const [BSTMList, setBSTMList] = useState<any>([]);
  const [adminIsSyncing, setAdminIsSyncing] = useState(false);
  const [syncAdmin, setSyncAdmin] = useState(0);
  const [levels, setLevels] = useState<any[]>([])

  const [libraryStats, setLibraryStats] = useState({
    total: 0,
    bst: 0,
    audio: 0,
    video: 0,
    book: 0,
    others: 0,
  });



  const libraryItems_sub = [
    {
      id: 1,
      title: 'Faith Over Fear – Bible Study 1',
      description: 'An introduction to walking by faith and overcoming fear.',
      youtube_id: 'abc123',
      youtubeUrl: 'https://youtube.com/watch?v=abc123',
      thumbnail: 'https://i.ytimg.com/vi/abc123/hqdefault.jpg',
      date: '2025-07-18T10:00:00Z',
      duration: '25:10',
      speaker: 'Pastor Splendour',
      library_type: 'bst', // or 'audio', 'book', etc.
      format: 'video',
      studyNotes: {
        visible: true,
        content: 'In this study, we explore biblical foundations of courage and trust in God...',
      },
    },
    {
      id: 2,
      title: 'Walking in Grace – Audio Session',
      description: 'An audio session focused on living in God’s grace daily.',
      youtube_id: 'def456',
      youtubeUrl: 'https://youtube.com/watch?v=def456',
      thumbnail: 'https://i.ytimg.com/vi/def456/hqdefault.jpg',
      date: '2025-07-16T08:30:00Z',
      duration: '30:45',
      speaker: 'Pastor Splendour',
      library_type: 'audio',
      format: 'audio',
      studyNotes: {
        visible: false,
        content: '',
      },
    },
    {
      id: 3,
      title: 'Understanding God’s Love – Book',
      description: 'A deep dive into the nature of God’s love through scripture.',
      youtube_id: 'ghi789',
      youtubeUrl: 'https://youtube.com/watch?v=ghi789',
      thumbnail: 'https://i.ytimg.com/vi/ghi789/hqdefault.jpg',
      date: '2025-07-20T12:00:00Z',
      duration: '1:15:30',
      speaker: 'Pastor Splendour',
      library_type: 'book',
      format: 'pdf',
      studyNotes: {
        visible: true,
        content: 'This book explores the depth and breadth of God’s love as revealed in the Bible...',
      },
    },
    {
      id: 4,
      title: 'Living in the Spirit – Video Teaching',
      description: 'A video teaching on the role of the Holy Spirit in our lives.',
      youtube_id: 'jkl012',
      youtubeUrl: 'https://youtube.com/watch?v=jkl012',
      thumbnail: 'https://i.ytimg.com/vi/jkl012/hqdefault.jpg',
      date: '2025-07-22T14:00:00Z',
      duration: '40:20',
      speaker: 'Pastor Splendour',
      library_type: 'video',
      format: 'video',
      studyNotes: {
        visible: true,
        content: 'In this session, we learn how to be led by the Holy Spirit in our daily walk...',
      },
    },
    {
      id: 5,
      title: 'Prayer and Intercession – Audio Guide',
      description: 'An audio guide on effective prayer and intercession techniques.',
      youtube_id: 'mno345',
      youtubeUrl: 'https://youtube.com/watch?v=mno345',
      thumbnail: 'https://i.ytimg.com/vi/mno345/hqdefault.jpg',
      date: '2025-07-24T16:00:00Z',
      duration: '50:10',
      speaker: 'Pastor Splendour',
      library_type: 'audio',
      format: 'audio',
      studyNotes: {
        visible: true,
        content: 'This guide provides practical tips for enhancing your prayer life...',
      },
    }
  ]

  const supplementaryItems_sub = [
    {
      id: 'note-101',
      label: 'Faith Series Notes (PDF)',
      type: 'pdf',
      url: '/docs/faith-series.pdf',
    },
    {
      id: 'gallery-001',
      label: 'Image Highlights',
      type: 'image',
      url: '/gallery/faith-week1.zip',
    },
  ]





  const [libraryItems, setLibraryItems] = useState([]); // Full list of all items
  const [supplementaryItems, setSupplementaryItems] = useState<any>([]); // Notes, PDFs, etc.
  const [includeSupplementary, setIncludeSupplementary] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSyncing, setIsSyncing] = useState(false);

  // Sync button handler (e.g., to fetch fresh data)

  const handleSync = async (includeSupplementary: boolean) => {
    setIsSyncing(true);
    setStatusMessage("Starting sync...");

    try {
      await syncYouTubeLibrary({
        API_KEY,
        channelId: "UCYWR5D0oC5lDGp_Yfh_EpFQ",
        includeSupplementary,
        supplementaryItems,
        onStatusUpdate: setStatusMessage,
      });
    } catch (e) {
      setStatusMessage("Sync failed.");
    } finally {
      setIsSyncing(false);
    }
  };

  // CRUD handler for supplementary items
  const onUpdateSupplementary = (updatedItems: any) => {
    setSupplementaryItems(updatedItems);
  };

  useEffect(() => {
    // get ActiveSection from URL query params on initial load
    const url = new URL(window.location.href);
    const sectionFromUrl = url.searchParams.get("section");
    if (sectionFromUrl) {
      setActiveSection(sectionFromUrl);
    }
  }, [])

  useEffect(() => {
    const handlePopState = () => {
      const url = new URL(window.location.href);
      const sectionFromUrl = url.searchParams.get("section") || "dashboard";
      setActiveSection(sectionFromUrl);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      const users = await getAllUsers();
      if (users) {
        setAllUsers(users);

        const admins = users.filter((user: any) =>
          user.roles?.some((role: string) => ['administrator', 'editor'].includes(role))
        );
        setAdminUsers(admins);
      }
    };
    const fetchComments = async () => {
      const all: any = await getAllComments();
      if (all) setComments(all);
    };
    const fetchAllPortals = async () => {
      // setLoading(true);

      const [thp, bbb, pmc, vtc] = await Promise.all([
        fetchTHPRegistrants(),
        fetchBBBRegistrants(),
        fetchPopMyCherryRegistrants(),
        fetchVTCRegistrants()
      ]);

      setPortals([
        { portal: "THP", data: thp },
        { portal: "BBB", data: bbb },
        { portal: "Pop My Cherry", data: pmc },
        { portal: "Teens Virtual Camp", data: vtc }
      ]);

      // setLoading(false);
    };
    const fetchPages = async () => {
      const all: any = await getAllPages();
      if (all) setAllPages(all);
    };
    const fetchAllLibrary = async () => {
      await fetchLibraryItems((currentList: any) => {
        setLibraryItems(currentList); // Updates list as it loads
      });
    };
    const fetchDeclarations = async () => {
      const items = await fetchDailyDeclarations();
      setDeclarations(items);
    }
    const fetchBioDataForm = async () => {
      const items = await fetchBioData();
      setBioDataList(items);
    }
    const fetchPartnerForm = async () => {
      const items = await fetchPartners();
      setPartnerFormList(items);
    }
    const fetchBSTMForm = async () => {
      const items = await fetchBSTM();
      setBSTMList(items);
    }
    const fetchVolunteersForm = async () => {
      const items = await fetchVolunteers();
      setVolunteersFormList(items);
    }
    const fetchLevels = async () => {
      const levels = await getWeeklyLevels()
      setLevels(levels)
    }




    setAdminIsSyncing(true)
    fetchUsers();
    fetchComments();
    fetchAllPortals();
    fetchPages();
    fetchAllLibrary();
    fetchDeclarations();
    fetchBioDataForm();
    fetchPartnerForm();
    fetchBSTMForm();
    fetchLevels();
    fetchVolunteersForm();
    setTimeout(() => {
      setAdminIsSyncing(false)
    }, 2000);
  }, [syncAdmin]);


  const handleAdminSync = async (includeSupplementary: boolean) => {
    let index = syncAdmin;
    setSyncAdmin(syncAdmin + 1);
  };

  const handleSectionChange = (section: string) => {
    setActiveSection(section)
    const url = new URL(window.location.href)
    url.searchParams.set("section", section)
    window.history.pushState({}, "", url)
  }

  const fullProps = {
    allUsers, adminUsers, comments, portals, allPages, handleSectionChange, levels, setLevels,
    libraryStats, libraryItems, setLibraryItems, supplementaryItems, handleSync, statusMessage, isSyncing, onUpdateSupplementary,
    includeSupplementary, setIncludeSupplementary, declarations, setDeclarations, bioDataList, setBioDataList, handleAdminSync, adminIsSyncing,
    partnerFormList, setPartnerFormList, volunteersFormList, setVolunteersFormList, BSTMList, setBSTMList
  }

  const renderSection = () => {
    switch (activeSection) {
      case "dashboard":
        return <DashboardSection {...fullProps} />
      case "healing-pavilion/healing-dashboard":
        return <HealingPavilionDashboard {...fullProps} />
      case "healing-pavilion/availability":
        return <HealingPavilionAvailabilityManagementPage {...fullProps} />
      case "healing-pavilion/bookings":
        return <HealingPavilionBookingsPage {...fullProps} />
      case "healing-pavilion/settings":
        return <HealingPavilionSettingsPage {...fullProps} />
      case "users":
        return <UserManagementSection {...fullProps} />
      case "registrants":
        return <PortalRegistrantsSection {...fullProps} />
      case "comments":
        return <CommentModerationSection {...fullProps} />
      case "qr-generator":
        return <QRGeneratorSection {...fullProps} />
      case "email-tools":
        // return <EmailToolsSection {...fullProps} />
        return <EnhancedEmailTools {...fullProps} />
      case "slider":
        return <SliderControlSection {...fullProps} />
      case "library-settings":
        return <LibrarySettingsSection {...fullProps} />
      case "daily-declaration":
        return <DailyDeclarationSection {...fullProps} />
      case "bio-data-form":
        return <BioDataFormSection {...fullProps} />
      case "partner-form":
        return <PartnerFormSection {...fullProps} />
      case "biblestudy-masterclass":
        return <BiblestudyMasterclassSection {...fullProps} />
      case "volunteer-form":
        return <VolunteersFormSection {...fullProps} />
      case "linktree":
        return <LinkTreeSection {...fullProps} />
      case "weekly-game":
        return <WeeklyGameAdminSection {...fullProps} />
      case "social-seo":
        return <SocialSEOSection {...fullProps} />
      case "site-settings":
        return <SiteSettingsSection {...fullProps} />
      case "notifications":
        return <NotificationsSection {...fullProps} />
      case "security":
        return <SecurityLogsSection {...fullProps} />
      default:
        return <DashboardSection {...fullProps} />
    }
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-[80vh] w-full">
        <AdminSidebar activeSection={activeSection} onSectionChange={handleSectionChange} />
        <SidebarInset className="flex-1">
          <AdminHeader activeSection={activeSection} />
          <main className="flex-1 p-6">{renderSection()}</main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  )
}
